module.exports = __webpack_public_path__ + "img/142.1.6dc031d6.jpg";